import { Flex } from '@chakra-ui/react';
import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';

import { localStorageKeys } from 'constants/localStorageKeys';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { setSelectedInitiativeType, useSelectInitiativeSelectedIntent } from '../slice/InitiativeIntentSlice';

export const setTimeBoundsToLS = (timeBounds) => {
  try {
    window.localStorage.setItem(localStorageKeys.teamPageGoalsTimeBounds, JSON.stringify(timeBounds));
  } catch (e) {
    console.error('Error in saving to LS: ', e);
  }
};

const MetaFilters = () => {
  const dispatch = useDispatch();

  const { initiativeTypes, selectedInitiativeType } = useSelectInitiativeSelectedIntent() ?? {};

  return (
    <Flex gap="12px">
      {/* <Dropdown>
        <DropdownTrigger asChild>
          <DropdownChip className="chip-dropdown">
            <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
              Data for :
            </TextBodyMedium>
            <TextBodyMedium bold color="text.g1">
              {selectedL1Label}
            </TextBodyMedium>
          </DropdownChip>
        </DropdownTrigger>
        <DropdownContent align="start" style={{ minWidth: '200px' }}>
          <DropdownRadioGroup value={l1Module}>
            {DATA_FOR_OPTIONS.filter((option) => option.label === 'Me')
              .filter((option) => option.visible())
              .map((option) => {
                const { label, value, type } = option;

                // Checking if the dataFor (value) is applicable for the selected intent
                if (applicableDataFor && !applicableDataFor[value]) {
                  return null;
                }
                if (type === 'RADIO') {
                  return (
                    <DropdownSub>
                      <DropdownSubTrigger>
                        <DropdownRadioItem key={value} value={value}>
                          {label}
                        </DropdownRadioItem>
                      </DropdownSubTrigger>
                      <DropdownSubContent>
                        <DropdownRadioGroup key={value} value={teamType}>
                          {option.options
                            .filter((option1) => option1.visible())
                            .map((radioOption) => (
                              <DropdownRadioItem
                                key={radioOption.value}
                                value={radioOption.value}
                                onSelect={() => onDataForChange(applicableDataFor[value][radioOption.value])}
                              >
                                {radioOption.label}
                              </DropdownRadioItem>
                            ))}
                        </DropdownRadioGroup>
                      </DropdownSubContent>
                    </DropdownSub>
                  );
                }

                return (
                  <DropdownRadioItem
                    key={value}
                    value={value}
                    onSelect={() => onDataForChange(applicableDataFor[value])}
                  >
                    {label}
                  </DropdownRadioItem>
                );
              })}
          </DropdownRadioGroup>
        </DropdownContent>
      </Dropdown> */}

      <Dropdown>
        <DropdownTrigger asChild>
          <DropdownChip className="chip-dropdown">
            <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
              Type :
            </TextBodyMedium>
            <TextBodyMedium bold color="text.g1">
              {selectedInitiativeType?.text ?? ''}
            </TextBodyMedium>
          </DropdownChip>
        </DropdownTrigger>
        <DropdownContent align="start" style={{ minWidth: '240px' }}>
          <DropdownRadioGroup value={selectedInitiativeType?.id}>
            {initiativeTypes?.map(({ text, id, enabled }) => (
              <DropdownRadioItem
                key={id}
                value={id}
                onClick={() => dispatch(setSelectedInitiativeType({ text, id, enabled }))}
              >
                {text}
              </DropdownRadioItem>
            ))}
          </DropdownRadioGroup>
        </DropdownContent>
      </Dropdown>

      {/* Removing for now as it needs fix from BE */}
      {/* <Dropdown>
        <DropdownTrigger asChild>
          <DropdownChip className="chip-dropdown">
            <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
              Duration :
            </TextBodyMedium>
            <Box display="inline-flex" alignItems="center" justifyContent="center" gap="4px">
              <TextBodyMedium bold color="text.g1">
                {selectedDateRange?.label || initialDateRange?.label || ''}
              </TextBodyMedium>
            </Box>
          </DropdownChip>
        </DropdownTrigger>
        <DropdownContent align="start" style={{ minWidth: '200px' }}>
          <DropdownRadioGroup value={selectedDateRange?.label || initialDateRange?.label}>
            {defaultRanges?.map((range) => (
              <DropdownRadioItem
                key={range?.label}
                value={range?.label}
                onClick={() => dispatch(setInitiativeDateRange(range))}
              >
                <Box display="inline-flex" alignItems="center" justifyContent="center" gap="4px">
                  {range?.label || ''}
                </Box>
              </DropdownRadioItem>
            ))}
          </DropdownRadioGroup>
        </DropdownContent>
      </Dropdown> */}
    </Flex>
  );
};

export { MetaFilters };
